import PropTypes from 'prop-types';
import React from 'react';

export default function Body(props) {
  return (
    <div
      style={props.style !== undefined ? props.style : undefined}
      className={(props.className ?? '') + ' card-component '}
      data-testid='body'
    >
      {props.children}
    </div>
  );
}

Body.propTypes = {
  className: PropTypes.string,
  style: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
};
